import React from "react";
import { Box, Container, Stack } from "@mui/material";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import { Link } from "react-router-dom";

export default function Highlights() {
  return (
    <div className="home-highlights-frame">
      <Container>
        <Stack className="home-highlights">
          <Box className="home-section-head">
            <Box className="home-section-titleblock">
              <Box className="category-title home-highlights-main-title">
                Why readers choose us
              </Box>
              <Box className="home-section-subtitle">
                A cleaner experience, curated books, and a community you'll
                actually enjoy.
              </Box>
            </Box>
            <Link to="/products" className="home-section-link">
              Start exploring
            </Link>
          </Box>

          <Stack className="home-highlight-grid">
            <Box className="home-highlight-card">
              <Box className="home-highlight-icon">
                <AutoStoriesOutlinedIcon />
              </Box>
              <Box className="home-highlight-title">Curated collections</Box>
              <Box className="home-highlight-text">
                Discover fiction, classics, and must-reads hand-picked for you.
              </Box>
            </Box>

            <Box className="home-highlight-card">
              <Box className="home-highlight-icon">
                <VerifiedOutlinedIcon />
              </Box>
              <Box className="home-highlight-title">Quality picks</Box>
              <Box className="home-highlight-text">
                Clean details, better previews, and transparent pricing.
              </Box>
            </Box>

            <Box className="home-highlight-card">
              <Box className="home-highlight-icon">
                <LocalShippingOutlinedIcon />
              </Box>
              <Box className="home-highlight-title">Fast ordering flow</Box>
              <Box className="home-highlight-text">
                Smooth browsing and checkout designed for speed on any device.
              </Box>
            </Box>
          </Stack>
        </Stack>
      </Container>
    </div>
  );
}

